import { render, staticRenderFns } from "./RecuperarSenhaView.vue?vue&type=template&id=78af1784&scoped=true"
import script from "./RecuperarSenhaView.vue?vue&type=script&lang=js"
export * from "./RecuperarSenhaView.vue?vue&type=script&lang=js"
import style0 from "./RecuperarSenhaView.vue?vue&type=style&index=0&id=78af1784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78af1784",
  null
  
)

export default component.exports